// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e1cc8ad3","633":"d1ec1a2f","766":"1f04474b","830":"28d7c948"}[chunkId] + ".chunk.js";
};